import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

import { tokens } from "./tokens";

interface Props {
    title?: string;
    subtitle?: string;
    style?: React.CSSProperties;
}

const useStyles = makeStyles(() => ({
    card: {
        background: tokens.surface,
        border: `1px solid ${tokens.line}`,
        borderRadius: "12px",
        padding: "22px 26px",
        boxShadow: tokens.shadow,
        marginBottom: "20px",
    },
    title: {
        fontSize: "15.5px",
        fontWeight: 600,
        color: tokens.ink,
        margin: "0 0 3px",
    },
    subtitle: {
        fontSize: "13px",
        color: tokens.hint,
        margin: "0 0 20px",
        maxWidth: "62ch",
    },
}));

export const ConsoleCard: React.FC<Props> = ({ title, subtitle, style, children }) => {
    const classes = useStyles();

    return (
        <div className={classes.card} style={style}>
            {title && <Typography component="h2" className={classes.title}>{title}</Typography>}
            {subtitle && <Typography component="p" className={classes.subtitle}>{subtitle}</Typography>}
            {children}
        </div>
    );
};
